import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authCreateAccountSlice from './Slice/CreateAccountSlice';
import authSlice from './Slice/AuthSlice';
import authDialogConfigSlice from './Slice/DialogSlice';
import allParameterSlice from './Slice/AllParameter';
import { ProfileAPI } from './api/ProfileAPI';
import { LoginAPI } from './api/LoginAPI';
import { AuftragAPI } from './api/AuftragAPI';
import { AdminProfileAPI } from './api/AdminProfileAPI';
import { StammdatenAPI } from './api/StammdatenAPI';
import { UserRoleAPI } from './api/UserRoleAPI';
import { TicketAPI } from './api/TicketAPI';
import { FakturaAPI } from './api/FakturaAPI';
import { ManagerAPI } from './api/ManagerAPI';
import { FileAPI } from './api/FileAPI';
import { AuftragMessagesAPI } from './api/AuftragMessagesAPI';
import { OfficeAPI } from './api/OfficeAPI';
import { ParameterAPI } from './api/ParameterAPI';
import toastReducer from "./Slice/ToastSlice";

const authReducers = combineSlices(
    authSlice
    , authDialogConfigSlice
    , authCreateAccountSlice
);

export const store = configureStore({
    reducer: {
        authSlice: authReducers,
        authReducer: authReducers,
        toast: toastReducer,

        allParameter: allParameterSlice.reducer,

        [LoginAPI.reducerPath]: LoginAPI.reducer,
        [AuftragAPI.reducerPath]: AuftragAPI.reducer,
        [ProfileAPI.reducerPath]: ProfileAPI.reducer,
        [AdminProfileAPI.reducerPath]: AdminProfileAPI.reducer,
        [StammdatenAPI.reducerPath]: StammdatenAPI.reducer,
        [UserRoleAPI.reducerPath]: UserRoleAPI.reducer,
        [TicketAPI.reducerPath]: TicketAPI.reducer,
        [FakturaAPI.reducerPath]: FakturaAPI.reducer,
        [ManagerAPI.reducerPath]: ManagerAPI.reducer,
        [FileAPI.reducerPath]: FileAPI.reducer,
        [AuftragMessagesAPI.reducerPath]: AuftragMessagesAPI.reducer,
        [OfficeAPI.reducerPath]: OfficeAPI.reducer,
        [ParameterAPI.reducerPath]: ParameterAPI.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat(
            AdminProfileAPI.middleware,
            LoginAPI.middleware,
            AuftragAPI.middleware,
            ProfileAPI.middleware,
            StammdatenAPI.middleware,
            UserRoleAPI.middleware,
            TicketAPI.middleware,
            FakturaAPI.middleware,
            ManagerAPI.middleware,
            FileAPI.middleware,
            AuftragMessagesAPI.middleware,
            OfficeAPI.middleware,
            ParameterAPI.middleware,
        )
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
